import styled from '@emotion/styled'

export const KPSharedLinkOrderSummaryStyle = styled.div`
  width: 426px;
  .cart-wrapper {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    gap: 40px;
    .cart-header {
      font-family: 'Open Sans', sans-serif;
      font-weight: 600;
      font-style: normal;
      font-size: 32px;
      line-height: 44px;
      letter-spacing: 0;
      color: #000000;
      margin-top: 25px;
      margin-bottom: -4px;
    }
    .cart-body {
      width: 100%;
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      align-items: flex-start;
      gap: 40px;
      .cart-items-wrap {
        width: 100%;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: flex-start;
        gap: 24px;
        .cart-items {
          width: 100%;
          display: flex;
          flex-direction: column;
          justify-content: flex-start;
          align-items: flex-start;
          gap: 12px;
          .item-title {
            font-family: 'Open Sans', sans-serif;
            font-weight: 600;
            font-style: normal;
            font-size: 20px;
            line-height: 44px;
            letter-spacing: 0;
            color: #000000;
          }
          .cart-item-wrap,
          .cart-addons-wrap {
            width: 100%;
            display: flex;
            flex-direction: column;
            justify-content: flex-start;
            align-items: flex-start;
            gap: 12px;
            .cart-plan-item {
              width: 100%;
              display: flex;
              justify-content: space-between;
              align-items: center;
              .item-header-text-wrap {
                display: flex;
                justify-content: flex-start;
                align-items: center;
                gap: 11px;
                .cart-plan-item-icon img {
                  width: 38px;
                  height: 38px;
                  opacity: 1;
                  border-bottom-right-radius: 6px;
                  border-bottom-left-radius: 6px;
                }
                .cart-plan-item-title {
                  font-family: 'Open Sans', sans-serif;
                  font-weight: 400;
                  font-style: normal;
                  font-size: 16px;
                  line-height: 30px;
                  letter-spacing: 0;
                  color: #121212;
                }
              }

              .cart-plan-item-amount {
                font-family: 'Open Sans', sans-serif;
                font-weight: 400;
                font-style: normal;
                font-size: 16px;
                line-height: 30px;
                letter-spacing: 0;
                color: #121212;
              }
            }
          }
          .order-coupons {
            width: 100%;
            display: flex;
            flex-direction: column;
            justify-content: flex-start;
            align-items: flex-start;
            gap: 12px;
            .coupon-item {
              width: 100%;
              display: flex;
              justify-content: space-between;
              align-items: center;
              height: 19px;
              .coupon-item-name {
                font-family: 'Open Sans', sans-serif;
                font-weight: 400;
                font-style: normal;
                font-size: 14px;
                line-height: 1;
                letter-spacing: 0;
                color: #121212;
              }
              // .coupon-item-btn {
              //   width: 16px;
              //   height: 16px;
              //   border: 1px solid #000000;
              //   border-radius: 50%;
              //   cursor: pointer;
              //   display: flex;
              //   justify-content: center;
              //   align-items: center;
              //   background: black;
              //   .c-btn {
              //     display: flex;
              //     justify-content: center;
              //     align-items: center;
              //     background: black;
              //     width: 8px;
              //     height: 8px;
              //     color: #ffffff;
              //   }
              // }
              .coupon-item-btn {
                width: 16px;
                height: 16px;
                // border: 1px solid #000000;
                // border-radius: 50%;
                cursor: pointer;
                display: flex;
                justify-content: center;
                align-items: center;
                .c-btn {
                  width: 8px;
                  height: 8px;
                  border-radius: 50%;
                  color: #000000;
                  background: #000000;
                }
              }
            }
          }
        }
      }
      .cart-total {
        width: 100%;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: center;
        gap: 6px;
        border-top: 1px solid #aaa;
        &.no-border-top {
          border-top: none;
        }
        .total-body {
          width: 100%;
          display: flex;
          justify-content: space-between;
          align-items: flex-start;
          .total-amount {
            font-family: 'Open Sans', sans-serif;
            font-weight: 600;
            font-style: normal;
            font-size: 20px;
            line-height: 44px;
            letter-spacing: 0;
            color: #000000;
          }
          .total-title {
            font-family: 'Open Sans', sans-serif;
            font-weight: 600;
            font-style: normal;
            font-size: 20px;
            line-height: 44px;
            letter-spacing: 0;
            color: #000000;
          }
        }
        .total-subtext {
          width: 100%;
          font-family: 'Open Sans', sans-serif;
          font-weight: 400;
          font-size: 12px;
          line-height: 100%;
          letter-spacing: 0;
          text-align: right;
          font-style: normal;
          color: #808080;
          display: flex;
          justify-content: flex-end;
        }
      }
      .cart-items:has(+ .cart-total) {
        & ~ .cart-total {
          border-top: none;
        }
      }
      .influencer-name-wrap {
        width: 100%;
        display: flex;
        justify-content: flex-start;
        align-items: flex-end;
        .influencer-name-input {
          width: 100%;
          display: flex;
          justify-content: center;
          align-items: center;
          padding: 8px 12px 4px;
          font-size: 16px;
          border-bottom: 1px solid #ccc;
          outline: 'none';
          color: #808080;
          font-family: 'Open Sans', sans-serif;
          font-weight: 400;
          font-style: normal;
          font-size: 14px;
          line-height: 20px;
          letter-spacing: 0;
        }
        .influencer-name-input:focus,
        .influencer-name-input:focus-visible {
          outline: none;
        }
      }
      .cart-action-btn-wrap {
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        .cart-action-btn {
          width: 350px;
          display: flex;
          flex-direction: column;
          justify-content: flex-start;
          align-items: center;
          gap: 12px;
          .generate-link-btn {
            width: 350px;
            height: 38px;
            display: flex;
            justify-content: center;
            border-radius: 4px;
            padding: 12px 16px;
            color: white;
            background: #ff5000;
            font-family: 'Open Sans', sans-serif;
            font-weight: 700;
            font-style: normal;
            font-size: 16px;
            line-height: 14px;
            letter-spacing: 0.005em;
            text-align: center;
            vertical-align: middle;
          }
          .generate-link-btn:disabled {
            // opacity: 0.5;
            cursor: not-allowed;
            color: #ffffff;
            background: var(
              --interaction-button-filled-disabled-background-color,
              #00000017
            );
          }
          .incentive-btn {
            width: 178px;
            height: 38px;
            opacity: 1;
            display: flex;
            gap: 8px;
            border-radius: 4px;
            padding: 12px 16px;
            color: #3c5199;
            font-family: 'Open Sans', sans-serif;
            font-weight: 600;
            font-style: normal;
            font-size: 16px;
            line-height: 14px;
            letter-spacing: 0.005em;
            text-align: center;
            vertical-align: middle;
          }
        }
      }
    }
  }
`

export const KPPromotionsStyle = styled.div`
  position: relative;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  .search-field-wrap {
    width: 100%;
    display: flex;
    justify-content: flex-start;
    align-items: flex-end;
    .search-input {
      width: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      padding: 8px 12px 4px;
      font-size: 16px;
      border-bottom: 1px solid #ccc;
      outline: 'none';
      color: #808080;
      font-family: 'Open Sans', sans-serif;
      font-weight: 400;
      font-style: normal;
      font-size: 14px;
      line-height: 20px;
      letter-spacing: 0;
    }
    .search-input:focus,
    .search-input:focus-visible {
      outline: none;
    }
    .search-act-btn {
      color: #808080;
      border: none;
      border-bottom: 1px solid #ccc;
      cursor: pointer;
      // width: 26px;
      // height: 26px;
    }
    .clear-input-btn {
      // padding: 2px 4px;
      display: flex;
      justify-content: center;
      align-items: center;
      font-weight: 600;
      font-size: 14px;
      // width: 28px;
      // heigt: 28px;
      padding: 2px 8px;
    }
    .search-icon-btn {
      padding: 4px 4px;
      img {
        width: 16px;
        height: 14px;
      }
    }
    .search-act-btn:hover {
      background: #f2f0f0;
      // border-radius: 4px;
      border-top-left-radius: 4px;
      border-top-right-radius: 4px;
    }
    .search-icon-btn:disabled {
      cursor: not-allowed;
      // color: #ffffff;
      // background: var(
      //   --interaction-button-filled-disabled-background-color,
      //   #00000017
      // );
    }
  }
`
export const KPPromotionsSearchDropDownStyle = styled.div`
  position: absolute;
  top: 34px;
  left: 0;
  right: 0;
  max-height: 200px;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  align-items: center;
  gap: 10px;
  padding: 0 0 20px;
  background: #ffffff;
  border: 1px solid #eceef1;
  border-bottom-left-radius: 0.75rem;
  border-bottom-right-radius: 0.75rem;
  box-shadow: 0px 5px 5px -3px #00000033, 0px 3px 14px 2px #0000001f,
    0px 8px 10px 1px #00000024;
  z-index: 100;
  overflow: auto;
  .dp-header {
    width: 100%;
    text-align: right;
    display: flex;
    justify-content: flex-end;
    padding: 4px 10px 0;
    font-weight: 600;
    .dp-header-btn {
      cursor: pointer;
      border-radius: 4px;
      width: 18px;
      height: 20px;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .dp-header-btn:hover {
      background: #f2f0f0;
    }
  }
  .dp-coupon-item {
    width: 100%;
    // height: 19px;
    padding: 2px 20px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 12px;
    font-family: 'Open Sans', sans-serif;
    font-weight: 400;
    font-style: normal;
    font-size: 14px;
    line-height: 1;
    letter-spacing: 0;
    color: #121212;

    .dp-coupon-item-name {
      color: #121212;
    }
    .dp-coupon-item-act-btn {
      cursor: pointer;
      color: white;
      background: #ff5000;
      font-weight: 600;
      padding: 4px 10px;
      border-radius: 4px;
    }
  }
`

export const KPGenerateLinkModalWrapStyle = styled.div`
  min-width: 460px;
  width: auto;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  gap: 16px;
  padding: 0 20px 10px;
  .link-loader {
    font-family: 'Open Sans', sans-serif;
    font-weight: 700; /* Bold */
    font-size: clamp(0.8125rem, 0.75rem + 0.3vw, 0.9375rem); /* 13px → 15px */
    line-height: clamp(0.875rem, 0.8rem + 0.3vw, 1.125rem); /* 14px → 18px */
    letter-spacing: 0.005em; /* ~0.5% of font size */
    text-align: center;
    color: #ff5000;
  }
`
export const KPGenerateLinkModalHeaderStyle = styled.div`
  font-family: 'Montserrat', sans-serif;
  font-weight: 600;
  font-size: 28px;
  line-height: 36px;
  letter-spacing: 0px;
  text-align: center;
  vertical-align: middle;
  color: #000000;
`
export const KPGenerateLinkModalBodyStyle = styled.div`
  .input-label {
    font-family: 'Open Sans', sans-serif;
    font-weight: 400;
    font-size: clamp(0.75rem, 0.65rem + 0.6vw, 1rem); /* 12px → 16px */
    line-height: clamp(1.25rem, 1.1rem + 0.4vw, 1.5rem); /* 15px → 24px */
    letter-spacing: 0;
    color: #808080;
  }
  .g-link-wrap {
    border-bottom: 1px solid #cccccc;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 0 2px 0;
    gap: 16px;
    .g-link {
      font-family: 'Open Sans', sans-serif;
      font-weight: 400;
      font-size: clamp(0.875rem, 0.8rem + 0.3vw, 1rem); /* 14px → 16px */
      line-height: clamp(1.25rem, 1.1rem + 0.4vw, 1.5rem); /* 20px → 24px */
      letter-spacing: 0;
      color: #231f20;
    }
    .gl-copy-btn {
      font-family: 'Open Sans', sans-serif;
      font-weight: 700; /* Bold */
      font-size: clamp(0.8125rem, 0.75rem + 0.3vw, 0.9375rem); /* 13px → 15px */
      line-height: clamp(0.875rem, 0.8rem + 0.3vw, 1.125rem); /* 14px → 18px */
      letter-spacing: 0.005em; /* ~0.5% of font size */
      text-align: center;
      vertical-align: middle;
      color: #ffffff;

      min-width: 100px;
      border-radius: 4px;
      padding: 9px 24px;
      // background: var(--interaction-button-text-disabled-text-color, #00000066);
      background: #ff5000;
      cursor: pointer;
      transition: all 0.3s ease;
    }
    .gl-copy-btn.gl-copied-btn {
      background: var(--green-green-200, #a3daa1);
    }
  }
  .gl-home-btn-wrap {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    margin: 20px 0 0;
    .gl-home-btn {
      min-width: 100px;
      font-family: 'Open Sans', sans-serif;
      font-weight: 700; /* Bold */
      font-size: clamp(0.8125rem, 0.75rem + 0.3vw, 0.9375rem); /* 13px → 15px */
      line-height: clamp(0.875rem, 0.8rem + 0.3vw, 1.125rem); /* 14px → 18px */
      letter-spacing: 0.005em; /* ~0.5% of font size */
      text-align: center;
      vertical-align: middle;
      // color: #ffffff;

      border-radius: 4px;
      padding: 9px 24px; /* top/bottom 9px, left/right 24px */
      // background: #ff5000;
      background: none;
      color: #ff5000;
      border: 1px solid #ff5000;
    }
  }

  // /* Responsive scaling */
  // @media (min-width: 640px) {
  //   /* sm */
  //   .input-label {
  //     font-size: 0.8125rem; /* ~13px */
  //     line-height: 1.3rem;
  //   }
  // }

  // @media (min-width: 1024px) {
  //   /* lg */
  //   .input-label {
  //     font-size: 0.875rem; /* 14px */
  //     line-height: 1.35rem;
  //   }
  // }

  // @media (min-width: 1440px) {
  //   /* xl / large desktops */
  //   .input-label {
  //     font-size: 1rem; /* 16px */
  //     line-height: 1.5rem;
  //   }
  // }
`

export const KPManageIncentiveModalWrapStyle = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  gap: 16px;
  padding: 0 20px 10px;
`
export const KPManagePlanIncentiveModalHeaderStyle = styled.div`
  font-family: 'Montserrat', sans-serif;
  font-weight: 600;
  font-size: 28px;
  line-height: 36px;
  letter-spacing: 0px;
  text-align: center;
  vertical-align: middle;
  color: #000000;
`
export const KPManagePlanIncentiveModalBodyStyle = styled.div`
  width: 100%;
  .pi-wrap {
    display: flex;
    flex-direction: column;
    gap: 6px;
    padding: 0 16px;
    .pi-title {
      font-family: 'Montserrat', sans-serif;
      font-weight: 600;
      font-size: 24px;
      line-height: 36px;
      letter-spacing: 0px;
      text-align: center;
      vertical-align: middle;
      color: #808080;
    }
    .pi-checkbox {
      width: 100%;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      gap: 6px;
      cursor: pointer;
      font-family: 'Open Sans', sans-serif;
      font-weight: 400;
      font-size: clamp(0.875rem, 0.8rem + 0.4vw, 1rem); /* 14px → 16px */
      line-height: clamp(1.25rem, 1.1rem + 0.5vw, 1.5rem); /* 20px → 24px */
      letter-spacing: 0;
      color: #121212;
      input {
        cursor: pointer;
      }
    }
  }
`
export const KPManagePlanIncentiveModalFooterStyle = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  .pi-close-btn {
    min-width: 100px;
    font-family: 'Open Sans', sans-serif;
    font-weight: 700; /* Bold */
    font-size: clamp(0.8125rem, 0.75rem + 0.3vw, 0.9375rem); /* 13px → 15px */
    line-height: clamp(0.875rem, 0.8rem + 0.3vw, 1.125rem); /* 14px → 18px */
    letter-spacing: 0.005em; /* ~0.5% of font size */
    text-align: center;
    vertical-align: middle;
    color: #ffffff;

    border-radius: 4px;
    padding: 9px 24px; /* top/bottom 9px, left/right 24px */
    background: #ff5000;
  }
`
